/* eslint-disable no-multi-spaces */
import React, { useContext, useReducer, useEffect, createContext } from "react";
import { ApplicationContext } from "@contexts/ApplicationContext";
import reducer, { propsToState } from "./reducer";
import { actionCreators } from "./actions";

export const AssetsContext = createContext({});

// NOTE: The assets component has its own internal state for
// things like which view it is on, if its loading etc.
// But we merge the props passed and its internal state to provide
// an overall state to the component.
export const AssetsProvider = (props) => {
  const { trackingDetails } = useContext(ApplicationContext);
  const [internalState, dispatch] = useReducer(reducer, propsToState(props));
  const stateWithProps = { ...props, ...internalState };

  const actionsWithDispatch = actionCreators(dispatch, stateWithProps);
  const { updateProps } = actionsWithDispatch;

  useEffect(
    () => updateProps(props),
    [props.scenario?.isRetired, props.assets]
  );

  return (
    <AssetsContext.Provider
      value={{
        state: stateWithProps,
        trackingDetails,
        actions: actionsWithDispatch,
      }}
    >
      {props.children}
    </AssetsContext.Provider>
  );
};
